const cartData = () => {
  return {
    code: '200',
    reason: 'sucess',
    data: {
      productItems: [
        {
          itemId: 'ddf4d06768fbec4eb6083aeaee',
          basePrice: 39,
          price: 78,
          qty: 2,
        },
      ],
      productTotal: 78,
      shippingTotal: 100,
      discount: 0,
      orderTotal: 178,
      totalqtyCount: 2,
    },
  };
};

const orderData = () => {
  return {
    code: '200',
    reason: 'sucess',
    data: {
      total: 1,
      page: 0,
      per_page: 20,
      rows: [
        {
          id: 10_037_798,
          ecorder_id: 10_037_998,
          order_date: '2022-01-11',
          order_no: '20220111090295',
          store_id: 45,
          store_name: '中平店',
          amount: 2171,
          code: null,
          order_amount: 2171,
          order_delivery_id: 1,
          order_delivery_name: 'C4',
          account: '0919328167',
          receiver_name: '在新莊',
          order_status_id: 20,
          order_status_name: '已訂貨',
          payment_status_id: 30,
          payment_status_name: '付款完成',
          delivery_date: '2022-01-11',
          shipping_status_id: 2,
          shipping_status_name: '開始撿貨',
          order_time: '2022-01-11 10:09:47',
          invoice_no: null,
          deliveryByVendor: false,
          sfcc_transaction_no: '90011622',
          ecStatus_id: '20',
          ecStatus_name: '已訂貨',
          payment_type_id: 1,
          payment_type_name: '信用卡一次付清',
          ecorder_source: true,
          payment_url: null,
          can_repay: false,
        },
      ],
    },
  };
};

const airecipeAiMessage = () => {
  return {
    code: '200',
    reason: '查詢成功',
    data: {
      total: 0,
      answer: '想幫您做出最對味的推薦，我還差一點線索！可以再告訴我更多嗎？',
      recipes: [],
    },
  };
};

const airecipeSettings = () => {
  return {
    code: '200',
    data: [
      {
        greetings: [
          '食譜小幫手來囉～我可以根據您提供的資訊，推薦適合的料理食譜喔。請試著說說今天的天氣、您現在的心情、感興趣的星座，或特定的節日或節慶喔！',
        ],
      },
    ],
    reason: '查詢成功',
  };
};

export { cartData, orderData, airecipeAiMessage, airecipeSettings };
